/**
 * CallToAction Component - Primary action section
 */

interface CallToActionProps {
    children: React.ReactNode;
}

export default function CallToAction({ children }: CallToActionProps) {
    return (
        <div className="relative bg-gradient-to-br from-[#0c2646] via-[#0c2646] to-[#0c2646] py-24" id="get-started">
            {/* Animated background */}
            <div className="absolute inset-0 opacity-20">
                <div className="absolute top-0 left-1/4 w-64 h-64 bg-[#2ba6bb] rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-500 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
            </div>

            <div className="relative w-full px-4 sm:px-6 lg:px-12 xl:px-20">
                <div className="max-w-4xl mx-auto text-center mb-12">
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6">
                        Ready to Transform Your Intranet?
                    </h2>
                    <p className="text-xl sm:text-2xl text-white/90 mb-4">
                        Join hundreds of organizations improving their SharePoint intranets
                    </p>
                    <p className="text-md text-white/70">
                        Start your free health check in seconds. No installation required.
                    </p>
                </div>
                <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-10 max-w-2xl mx-auto border border-white/20">
                    {children}
                </div>

                {/* Trust badges */}
                <div className="mt-12 flex flex-wrap justify-center items-center gap-8 text-white/70 text-sm font-medium">
                    <div className="flex items-center gap-2">
                        <svg className="w-5 h-5 text-[#2ba6bb]" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        100% Secure
                    </div>
                    <div className="flex items-center gap-2">
                        <svg className="w-5 h-5 text-[#2ba6bb]" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        No Installation
                    </div>
                    <div className="flex items-center gap-2">
                        <svg className="w-5 h-5 text-[#2ba6bb]" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        Instant Results
                    </div>
                </div>
            </div>
        </div>
    );
}
